<template>
  <div v-if="getProfile && getProfile.isAdmin" class="panel is-danger p-0">
    <p class="panel-heading">Admin Panel</p>

    <section class="notification" :class="id ? 'is-info' : 'is-success'">
      <b-field :label="id ? 'Edit notification' : 'Add notification'"></b-field>
      <div class="is-flex">
        <b-select v-model="formData.type">
          <option value="Normal" key="type1">Normal</option>
          <option value="Blocking" key="type2">Blocking</option>
        </b-select>

        <b-datepicker
          v-model="formData.fromDate"
          placeholder="Select a date"
          icon="calendar"
          editable
        />

        <b-datepicker
          v-model="formData.toDate"
          placeholder="Expiry date"
          icon="calendar"
          editable
        />

        <b-input
          v-model="formData.url"
          placeholder="https://..."
          class="is-flex-grow-1"
        />
      </div>

      <b-input v-model="formData.text" placeholder="Message" type="textarea" />

      <div class="is-flex">
        <b-taginput
          v-model="formData.usernames"
          placeholder="Add username"
          class="is-flex-grow-1"
        />

        <p class="control">
          <b-button type="is-warning" label="Cancel" @click="resetForm" />
          <b-button
            type="is-primary"
            label="Submit"
            :disabled="!formData.text || !formData.usernames"
            @click="handleSubmit"
          />
        </p>
      </div>
    </section>

    <table class="table is-fullwidth">
      <thead>
        <tr>
          <th style="width: 10%">Type</th>
          <th style="width: 10%">From Date</th>
          <th style="width: 10%">To Date</th>
          <th style="width: 10%">Url</th>
          <th style="width: 30%">Message</th>
          <th style="width: 15%">Usernames</th>
          <th style="width: 15%">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in news" :key="index">
          <td>{{ item.type }}</td>
          <td>{{ item.fromDate | asDate }}</td>
          <td>{{ item.toDate | asDate }}</td>
          <td>
            <a v-if="item.url" :href="item.url">
              {{ item.url ? item.url.slice(0, 15) + "..." : "" }}
            </a>
          </td>
          <td>{{ item.text }}</td>
          <td>
            <span
              v-for="username in item.usernames"
              :key="username"
              :class="
                item.seen && item.seen.includes(username)
                  ? 'has-text-success'
                  : ''
              "
            >
              {{ username }}&nbsp;
            </span>
          </td>
          <td>
            <b-button
              :type="item.isHidden ? '' : 'is-success'"
              :icon-right="item.isHidden ? 'eye-slash' : 'eye'"
              @click="toggleVisible(item)"
            />
            <b-button
              type="is-info"
              icon-right="pen"
              @click="handleEdit(item)"
            />
            <b-button
              type="is-danger"
              icon-right="trash"
              @click="handleDelete(item)"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { firestore } from "@/services/firebase";
import { mapGetters } from "vuex";

const notificationsRef = firestore.collection("notifications");
const defaultFromData = {
  type: "Normal",
  fromDate: new Date(),
  toDate: null,
  usernames: [],
  text: null,
  url: null,
};

export default {
  name: "AdminNotifications",

  data() {
    return {
      id: null,
      formData: { ...defaultFromData },
      news: [],
    };
  },

  computed: {
    ...mapGetters(["getProfile"]),
  },

  firestore: {
    news: notificationsRef.orderBy("fromDate", "desc"),
  },

  methods: {
    resetForm() {
      this.id = null;
      this.formData = { ...defaultFromData };
    },

    handleSubmit() {
      if (this.id) {
        notificationsRef.doc(this.id).update(this.formData);
      } else {
        notificationsRef.add(this.formData);
      }
      this.resetForm();
    },

    toggleVisible(item) {
      notificationsRef.doc(item.id).update({
        isHidden: !item.isHidden,
      });
    },

    handleEdit(item) {
      this.id = item.id;
      this.formData.fromDate = item.fromDate ? item.fromDate.toDate() : null;
      this.formData.toDate = item.toDate ? item.toDate.toDate() : null;
      this.formData.usernames = item.usernames;
      this.formData.text = item.text;
      this.formData.url = item.url;
    },

    handleDelete(item) {
      notificationsRef.doc(item.id).delete();
    },
  },
};
</script>

<style scoped></style>
